export const SET_PRECONTRACTS_META = 'SET_PRECONTRACTS_META';
export const SET_DOCUMENTS_META = 'SET_DOCUMENTS_META';
